import { ChangeEvent, useEffect, useState /*useMemo*/ } from 'react';
import { useLocation } from 'react-router-dom';
//import { IconName } from '@fortawesome/fontawesome-svg-core';
import { t } from 'i18next';
import {
  Button,
  // ButtonIconPosition,
  // ButtonPropsTypes,
  ButtonSize,
  ButtonStyles,
  // ButtonType,
  ButtonTypes,
  ButtonWidth,
  Card,
  Checkbox,
  DetailCardProgress,
  Drawer,
  HeaderStyle,
  // IconButton,
  // IconButtonProps,
  // IconPropInterface,
  // IconStyle,
  ImageSlider,
  Input,
  InputTypes,
  MLPVersion,
  Modal,
  TableContainer,
  Tag,
  TagStyle,
  TextAlign,
  TextArea,
  Theme,
  Tooltip,
  TooltipPreference,
  //DatePicker,
  useBreakpoint,
} from '../../../../ui/components';
import {
  dateTimeToCustomFormat,
  LoggerService,
  PAGES,
  formatDateDMYYYY,
  trackPage,
  // processBeforeAfterImagesData,
  // processBeforeAfterImagesResponse,
  processProfilePictureData,
  //encryptString,
} from '../../../../ui/utils';
import OperationCenterErrorCard, {
  ErrorType,
} from '../../../../ui/components/OperationCenterErrorCard/OperationCenterErrorCard';
import { useAdminToast } from '../../../../ui/components/AdminToast/AdminToast';
import { customEventPropType } from '../../../../ui/components/ImageEditor/types/propsType';
import ImageEditor from '../../../../ui/components/ImageEditor/ImageEditor';
import personalizeImg from '../../../../assets/image/personalize.png';
import { GetColumnsType } from '../../../../ui/components/TableContainer/types/propsTypes';
//import TableWithAction from '../../../../ui/components/TableWithAction/TableWithAction';
//import { MenuItem } from '../../../../ui/components/Menu/Menu';
import intermediateMeasurementService from '../../../../sdk/services/intermediateMeasurementService';
//import CirclePlusGreen from '../../../../assets/image/icons/circle-plus-green.svg';
import PhotoUnavailable from '../../../../assets/image/sample/photoUnavailable.png';
import { getRoundedNumber } from '../../../../ui/utils/common';
import { decryptString } from '../../../../ui/utils/cryptoUtils';
import ParticipantService from '../../../../sdk/services/participantService';
import type { DynamicObjectInterface, AttachmentImageBA } from '../../../../sdk/type';
import healthGoalService from '../../../../sdk/services/healthGoalService';
import { CampaignQuestionType, UserAnswerDataType } from '../../[campaignId]';
import ChangeButton from '../../../../../src/assets/image/icons/change_button.svg';
import RemoveButton from '../../../../../src/assets/image/icons/remove_button.svg';
import { useAPICall } from '../../../../hooks';
import AttachmentService from '../../../../sdk/services/attachmentService';
import '../../../../sdk/services/axiosInterceptor';
import styles from './index.module.scss';

export interface ParticipantData {
  campaign: {
    campaignName: string;
    campaignStart: string;
    campaignEnd: string;
  };
  coachID: string;
  coachName: string;
  email: string;
  isNewAbo: number;
  isTeamLeader: boolean;
  loginId: string;
  name: string;
  phone: string;
  pinLevel: number;
  point: PointData;
  purchase: {
    recId?: number;
    orderPoint?: number;
    orderNumber?: string;
    orderName?: string;
  }[];
  remark: string;
  campaignStatRecId?: number;
  rewards: {
    activityName?: string;
    rewardRemarks?: string;
    rewardId?: number;
    rewardCode?: string;
    rewardName?: string;
    rewardType?: string;
    isNew?: boolean;
    redeemDate?: string;
    rewardRecId: string;
    rewardStatus?: string;
  }[];
  status: string;
  subscribe: {
    recId?: number;
    orderPoint?: number;
    orderNumber?: string;
  }[];
  subscribeCheck?: string;
  team: {
    teamName: string;
    teamStartDate: string;
    teamEndDate: string;
    teamLeaderLoginId: string;
    teamLeaderName: string;
  };
  weightIn: {
    acknowledgeBy?: string;
    acknowledgeByName?: string;
    acknowledgeDateTime?: string;
    bodyFat: number;
    height: number;
    machine: string;
    muscleKilogram: number;
    musclePercentage: number;
    weightedDate: string;
    weight: number;
    remarks: string;
    // for DetailCardProgress
    weightInDate: string;
  };
  weightOut: {
    acknowledgeBy?: string;
    acknowledgeByName?: string;
    acknowledgeDateTime?: string;
    bodyFat: number | null;
    height: number | null;
    machine: string;
    muscleKilogram: number | null;
    musclePercentage: number | null;
    weightedDate: string;
    weight: number | null;
    remarks: string;
    // for DetailCardProgress
    weightOutDate: string;
  };
  weightOutDiffValues: {
    bodyFatDiff?: number;
    muscleKilogramDiff?: number;
    musclePercentageDiff?: number;
    weightDiff?: number;
    result?: boolean;
  };
  // for DetailCardProgress
  hideProfileImg: boolean;
  showFiveProgress: boolean;
  points?: {
    product: number;
    result: number;
    subscribe: number;
  };
}

export interface PointData {
  purchase?: number;
  purchaseAdj?: number;
  subscribe?: number;
  subscribeAdj?: number;
  winning?: number;
  winningAdj?: number;
  remarks: string;
}

export interface ProgressType {
  weighingDate: Date;
  weight: number;
  bodyFat: number;
  muscleKilogram: number;
  checked: boolean;
}

export const TeamProfile = (props: {
  decodedData: DynamicObjectInterface;
  role: 'LEADER' | 'COACH' | 'PARTICIPANT';
}) => {
  const [urlParamValue, setUrlParamValue] = useState({
    campaignId: '',
    teamId: '',
    userId: '',
  });
  const [data, setData] = useState<ParticipantData>();
  const [alpValue, setAlpValue] = useState<{ input: string; check: boolean }>({ input: '', check: false });
  const [activityNames, setActivityNames] = useState<(string | undefined)[]>([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [images, setImages] = useState<Record<string, AttachmentImageBA>>({
    before_front: { photoId: 0, url: '', file: null },
    after_front: { photoId: 0, url: '', file: null },
    before_side: { photoId: 0, url: '', file: null },
    after_side: { photoId: 0, url: '', file: null },
  });

  const [profileImageUrl, setProfileImageUrl] = useState<string | undefined>('');
  const [profileImageFile, setProfileImageFile] = useState<File | null>(null);
  // const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // const [carouselType, setCarouselType] = useState('');

  const apiCall = useAPICall();
  const location = useLocation();
  // const navigate = useNavigate();
  const viewPortType = useBreakpoint();
  const { adminToast } = useAdminToast();
  const isDesktopView = ['xs', 'sm', 'md'].indexOf(viewPortType) === -1;

  useEffect(() => {
    setUrlParamValue(prev => {
      const paths = location.pathname.split('/');
      const teamsIdx = paths.includes('teams')
        ? paths.indexOf('teams')
        : paths.includes('participants')
          ? paths.indexOf('participants')
          : paths.indexOf('myTeam');
      if (teamsIdx !== -1 && teamsIdx + 1 < paths.length) {
        prev.campaignId = decodeURIComponent(paths[teamsIdx - 1]);
        prev.teamId = decodeURIComponent(paths[teamsIdx + 1]);
      }
      const params = new URLSearchParams(location.search);
      const userId = params.get('id') ?? '';
      prev.userId = userId;
      const myTeamIdx = paths.indexOf('myTeam');
      if (myTeamIdx !== -1 && myTeamIdx + 1 < paths.length) {
        prev.campaignId = decodeURIComponent(paths[myTeamIdx - 1]);
        prev.teamId = params.get('tId') ?? '';
      }
      return { ...prev };
    });
    fetchData();

    const timeout = setTimeout(() => {
      trackPage(PAGES.teamProfile);
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [location]);

  const fetchData = async () => {
    const res = await apiCall(ParticipantService.getParticipantDetail, urlParamValue, urlParamValue.userId);
    if (res.data.data) {
      let _data: ParticipantData = res.data.data;
      _data.hideProfileImg = true;
      _data.showFiveProgress = true;
      _data.weightIn.weightInDate = _data.weightIn.weightedDate;
      _data.weightOut.weightOutDate = _data.weightOut.weightedDate;
      if (props.role === 'COACH') {
        _data.points = {
          product: (_data.point.purchase ?? 0) + (_data.point.purchaseAdj ?? 0),
          result: (_data.point.winning ?? 0) + (_data.point.winningAdj ?? 0),
          subscribe: (_data.point.subscribe ?? 0) + (_data.point.subscribeAdj ?? 0),
        };
      }
      _data = {
        ..._data,
        weightIn: {
          ..._data.weightIn,
          bodyFat: _data?.weightIn?.bodyFat
            ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightIn?.bodyFat}`)))
            : 0,
          height: _data?.weightIn?.height
            ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightIn?.height}`)))
            : 0,
          muscleKilogram: _data?.weightIn?.muscleKilogram
            ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightIn?.muscleKilogram}`)))
            : 0,
          musclePercentage: _data?.weightIn?.musclePercentage
            ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightIn?.musclePercentage}`)))
            : 0,
          weight: _data?.weightIn?.weight
            ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightIn?.weight}`)))
            : 0,
        },
        weightOut: {
          ..._data.weightOut,
          bodyFat: _data?.weightOut?.bodyFat
            ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightOut?.bodyFat}`)))
            : null,
          height: _data?.weightOut?.height
            ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightOut?.height}`)))
            : null,
          muscleKilogram: _data?.weightOut?.muscleKilogram
            ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightOut?.muscleKilogram}`)))
            : null,
          musclePercentage: _data?.weightOut?.musclePercentage
            ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightOut?.musclePercentage}`)))
            : null,
          weight: _data?.weightOut?.weight
            ? getRoundedNumber(parseFloat(decryptString(`${_data?.weightOut?.weight}`)))
            : null,
        },
      };
      setData(_data);
      setAlpValue(prev => ({ ...prev, input: _data?.subscribe?.map(i => i.orderNumber)?.join(', ') }));

      let _activityNames = _data.rewards
        .filter((r, idx, self) => idx === self.findIndex(t => t.activityName === r.activityName))
        .map(r => r.activityName);
      setActivityNames(_activityNames);
    }
  };

  // const goBack = () => {
  //   let idx = location.pathname.indexOf('/user');
  //   if (idx !== -1) {
  //     let url = location.pathname.substring(0, idx);
  //     navigate(url);
  //   }
  // };

  // return (
  //   <div className={styles['team-profile']}>
  //     <div className={styles['team-profile-header']}>
  //       <IconButton iconName="chevron-left" iconStyle={IconStyle.SOLID} theme={Theme.WHITE} onClick={() => goBack()} />
  //       <h2>Participant Profile</h2>
  //     </div>
  //     <div className={styles['team-profile-top']}>
  //       <Card
  //         title="Participant Details"
  //         headerStyle={HeaderStyle.HEADER_6}
  //         classes={styles['team-profile-top-layout-1']}
  //       >
  //         <div className={styles['profile-content']}>
  //           <div className={styles['profile-content-image-container']}>
  //             <img
  //               src={profileImageUrl ? profileImageUrl : personalizeImg}
  //               width={96}
  //               height={96}
  //               alt="personalize"
  //               onClick={props.decodedData.name === data?.name ? showModalFn : undefined}
  //               className={styles['main-profile-image']}
  //             />
  //           </div>
  //           {data?.isTeamLeader && (
  //             <div className={`${styles['profile-content-team-leader']} ${styles['profile-content-tag']}`}>
  //               {'Team Leader'.toLocaleUpperCase()}
  //             </div>
  //           )}
  //           {data?.isNewAbo === 1 && (
  //             <div className={`${styles['profile-content-new-abo']} ${styles['profile-content-tag']}`}>
  //               {'new abo'.toLocaleUpperCase()}
  //             </div>
  //           )}
  //           <div className={styles['profile-content-info']}>
  //             <div className={styles['profile-content-label']}>Name</div>
  //             <div className={`${styles['profile-content-tag']}`}>{data?.name}</div>
  //           </div>
  //           <div className={styles['profile-content-info']}>
  //             <div className={styles['profile-content-label']}>ABO No.</div>
  //             <div className={`${styles['profile-content-tag']}`}>{data?.loginId}</div>
  //           </div>
  //           <div className={styles['profile-content-info']}>
  //             <div className={styles['profile-content-label']}>Mobile No.</div>
  //             <div className={`${styles['profile-content-tag']}`}>{data?.phone}</div>
  //           </div>
  //           <div className={styles['profile-content-info']}>
  //             <div className={styles['profile-content-label']}>Email</div>
  //             <div className={`${styles['profile-content-tag']} ${styles['email']}`}>{data?.email ?? '-'}</div>
  //           </div>
  //         </div>
  //         <div className={styles['progress-monitoring-horizontal-line']} />
  //         {/* health goal section  */}
  //         <div>
  //           <div className={styles['progress-monitoring-title-container']}>
  //             <div className={styles['progress-monitoring-title-container-title']}>Health Goal</div>
  //             <div className={styles['progress-monitoring-title-container-subtitle']}>(Optional)</div>
  //             <Tooltip
  //               message={
  //                 'Your health goals are optional and for your records only, to help you keep track of your activity.'
  //               }
  //               preference={TooltipPreference.RIGHT}
  //               className={styles['input-tool-tip']}
  //             />
  //           </div>
  //           {userAnswerData?.answerText !== undefined && userAnswerData?.answerText !== null ? (
  //             <div className={styles['health-goal-section']}>
  //               <div className={styles['health-goal-content']}>{userAnswerData?.answerText}</div>
  //               {/* <div className={styles['health-goal-button-section']}>
  //                 <button
  //                   onClick={(event) => {
  //                     event.stopPropagation();
  //                     setActionMenu(true);
  //                   }}
  //                   className={`${styles['health-goal-button']}`}
  //                 >
  //                   ...
  //                 </button>
  //                 {menu}
  //               </div> */}
  //             </div>
  //           ) : (
  //             <div className={styles['health-goal-add-goals']}>
  //               <Button
  //                 size={ButtonSize.SMALL}
  //                 theme={Theme.GREEN}
  //                 className={styles['health-goal-button-styles']}
  //                 title={'+ Add Goals'}
  //                 onClick={() => {
  //                   setAddHealthGoalModal(true);
  //                 }}
  //                 buttonWidth={ButtonWidth.FULL_WIDTH}
  //                 buttonStyle={ButtonStyles.OUTLINE}
  //               />
  //             </div>
  //           )}
  //         </div>
  //         {healthGoalModal}
  //       </Card>
  //       <Card
  //         title="Body Composition Assessment"
  //         headerStyle={HeaderStyle.HEADER_6}
  //         classes={styles['team-profile-top-layout-2']}
  //         buttonType={
  //           (data?.subscribe ?? [])?.length > 0 && data?.subscribe[0].orderNumber !== null
  //             ? ButtonType.ICON
  //             : ButtonType.TEXT
  //         }
  //         button={getButtonConfig.alp}
  //         buttonLabel={getButtonLabelConfig}
  //       >
  //         {isDesktopView ? (
  //           <div className={styles['measurement']}>
  //             <div className={styles['measurement-container']}>
  //               <div className={styles['measurement-carousel']}>
  //                 <ImageSlider
  //                   id="beforeImg"
  //                   slides={[
  //                     {
  //                       src: images.before_front.url ? images.before_front.url : PhotoUnavailable,
  //                       alt: 'Before Front View',
  //                     },
  //                     {
  //                       src: images.before_side.url ? images.before_side.url : PhotoUnavailable,
  //                       alt: 'Before Side View',
  //                     },
  //                   ]}
  //                   onClick={() => handleImageUpload('before')}
  //                 />
  //               </div>
  //               <div className={styles['measurement-info']}>
  //                 <div className={styles['measurement-info-title']}>Before</div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Weigh-In Date</p>
  //                   <p>
  //                     {data?.weightIn.weightedDate ? (
  //                       <Tag
  //                         text={formatDateDMYYYY(new Date(data.weightIn.weightedDate))}
  //                         theme={Theme.SUCCESS}
  //                         style={TagStyle.OUTLINE}
  //                       />
  //                     ) : (
  //                       '-'
  //                     )}
  //                   </p>
  //                 </div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Machine</p>
  //                   <p>{data?.weightIn.machine ?? '-'}</p>
  //                 </div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Height (cm)</p>
  //                   <p>{data?.weightIn.height ?? '-'}</p>
  //                 </div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Weight (kg)</p>
  //                   <p>{data?.weightIn.weight ?? '-'}</p>
  //                 </div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Body Fat (%)</p>
  //                   <p>{data?.weightIn.bodyFat ?? '-'}</p>
  //                 </div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Muscle Mass (kg)</p>
  //                   <p>{data?.weightIn.muscleKilogram ?? '-'}</p>
  //                 </div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Muscle Mass (%)</p>
  //                   <p>{data?.weightIn.musclePercentage ?? '-'}</p>
  //                 </div>
  //               </div>
  //             </div>
  //             <div className={styles['measurement-container']}>
  //               <div className={styles['measurement-carousel']}>
  //                 <ImageSlider
  //                   id="afterImg"
  //                   slides={[
  //                     {
  //                       src: images.after_front.url ? images.after_front.url : PhotoUnavailable,
  //                       alt: 'After Front View',
  //                     },
  //                     {
  //                       src: images.after_side.url ? images.after_side.url : PhotoUnavailable,
  //                       alt: 'Afer Side View',
  //                     },
  //                   ]}
  //                   onClick={() => handleImageUpload('after')}
  //                 />
  //               </div>
  //               <div className={styles['measurement-info']}>
  //                 <div className={styles['measurement-info-title']}>After</div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Post-Assessment Date</p>
  //                   <p>
  //                     {data?.weightOut.weightedDate ? (
  //                       <Tag
  //                         text={formatDateDMYYYY(new Date(data.weightOut.weightedDate))}
  //                         theme={Theme.SUCCESS}
  //                         style={TagStyle.OUTLINE}
  //                       />
  //                     ) : (
  //                       '-'
  //                     )}
  //                   </p>
  //                 </div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Machine</p>
  //                   <p>{data?.weightOut.machine ?? '-'}</p>
  //                 </div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Height (cm)</p>
  //                   <p>{data?.weightOut.height ?? '-'}</p>
  //                 </div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Weight (kg)</p>
  //                   <p>
  //                     {data?.weightOut.weight && data.weightIn.weight ? (
  //                       <>
  //                         {data.weightOut.weight}
  //                         <span
  //                           className={styles['measurement-info-label-diff']}
  //                         >{`(${data.weightOutDiffValues.weightDiff?.toFixed(1)})`}</span>
  //                       </>
  //                     ) : (
  //                       '-'
  //                     )}
  //                   </p>
  //                 </div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Body Fat (%)</p>
  //                   <p>
  //                     {data?.weightOut.bodyFat && data.weightIn.bodyFat ? (
  //                       <>
  //                         {data.weightOut.bodyFat}
  //                         <span
  //                           className={styles['measurement-info-label-diff']}
  //                         >{`(${data.weightOutDiffValues.bodyFatDiff?.toFixed(1)})`}</span>
  //                       </>
  //                     ) : (
  //                       '-'
  //                     )}
  //                   </p>
  //                 </div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Muscle Mass (kg)</p>
  //                   <p>
  //                     {data?.weightOut.muscleKilogram && data.weightIn.muscleKilogram ? (
  //                       <>
  //                         {data.weightOut.muscleKilogram}{' '}
  //                         <span
  //                           className={styles['measurement-info-label-diff']}
  //                         >{`(${data.weightOutDiffValues.muscleKilogramDiff?.toFixed(1)})`}</span>
  //                       </>
  //                     ) : (
  //                       '-'
  //                     )}
  //                   </p>
  //                 </div>
  //                 <div className={styles['measurement-info-field']}>
  //                   <p className={styles['measurement-info-label']}>Muscle Mass (%)</p>
  //                   <p>
  //                     {data?.weightOut.musclePercentage && data.weightIn.musclePercentage ? (
  //                       <>
  //                         {data.weightOut.musclePercentage}
  //                         <span
  //                           className={styles['measurement-info-label-diff']}
  //                         >{`(${data.weightOutDiffValues.musclePercentageDiff?.toFixed(1)})`}</span>
  //                       </>
  //                     ) : (
  //                       '-'
  //                     )}
  //                   </p>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         ) : (
  //           <>
  //             <div className={styles['result-container-mobile']}>
  //               <div></div>
  //               <div className={styles['result-container-mobile-wrapper']}>
  //                 <div className={styles['carousel-container']}>
  //                   <ImageSlider
  //                     id="beforeImg"
  //                     slides={[
  //                       {
  //                         src: images.before_front.url ? images.before_front.url : PhotoUnavailable,
  //                         alt: 'Before Front View',
  //                       },
  //                       {
  //                         src: images.before_side.url ? images.before_side.url : PhotoUnavailable,
  //                         alt: 'Before Side View',
  //                       },
  //                     ]}
  //                     onClick={() => handleImageUpload('before')}
  //                   />
  //                 </div>
  //                 {/*<div className={styles['result-container-mobile-photo-button']}>Tap for Details</div> */}
  //                 <div className={styles['result-container-mobile-title']}>Before</div>
  //               </div>
  //               <div></div>
  //               <div className={styles['result-container-mobile-wrapper']}>
  //                 <div className={styles['carousel-container']}>
  //                   <ImageSlider
  //                     id="afterImg"
  //                     slides={[
  //                       {
  //                         src: images.after_front.url ? images.after_front.url : PhotoUnavailable,
  //                         alt: 'After Front View',
  //                       },
  //                       {
  //                         src: images.after_side.url ? images.after_side.url : PhotoUnavailable,
  //                         alt: 'After Side View',
  //                       },
  //                     ]}
  //                     onClick={() => handleImageUpload('after')}
  //                   />
  //                 </div>
  //                 {/* <div className={styles['result-container-mobile-photo-unavailable']}>Photo Unavailable</div> */}
  //                 <div className={styles['result-container-mobile-title']}>After</div>
  //               </div>
  //             </div>
  //             <div className={styles['result-container-mobile']}>
  //               <div></div>
  //               <div className={styles['result-container-mobile-wrapper']}>
  //                 <div className={styles['result-container-mobile-header-label']}>Pre-Assessment Date:</div>
  //                 <div className={`${styles['tag-calendar']} ${styles['result-container-mobile-date']}`}>
  //                   {data?.weightIn?.weightedDate ? (
  //                     <Tag
  //                       theme={Theme.SUCCESS}
  //                       text={formatDateDMYYYY(new Date(data?.weightIn?.weightedDate))}
  //                       style={TagStyle.OUTLINE}
  //                     />
  //                   ) : (
  //                     '-'
  //                   )}
  //                 </div>
  //               </div>
  //               <div className={styles['vertical-line-mobile']}></div>
  //               <div className={styles['result-container-mobile-wrapper']}>
  //                 <div className={styles['result-container-mobile-header-label']}>Post-Assessment Date:</div>
  //                 <div className={styles['tag-calendar']}>
  //                   {data?.weightOut?.weightedDate ? (
  //                     <Tag
  //                       theme={Theme.SUCCESS}
  //                       text={formatDateDMYYYY(new Date(data?.weightOut?.weightedDate))}
  //                       style={TagStyle.OUTLINE}
  //                     />
  //                   ) : (
  //                     '-'
  //                   )}
  //                 </div>
  //               </div>
  //             </div>
  //             <div className={styles['result-container-mobile']}>
  //               <div>
  //                 <div className={styles['result-container-mobile-label']}>Machine</div>
  //                 <div className={styles['result-container-mobile-label']}>Height (cm)</div>
  //                 <div className={styles['result-container-mobile-label']}>Weight (kg)</div>
  //                 <div className={styles['result-container-mobile-label']}>Body Fat (%)</div>
  //                 <div className={styles['result-container-mobile-label']}>Muscle Mass (kg)</div>
  //                 <div className={styles['result-container-mobile-label']}>Muscle Mass (%)</div>
  //                 <div className={styles['result-container-mobile-label']}>Acknowledgement By</div>
  //                 <div className={styles['result-container-mobile-label']}>Acknowledgement Date</div>
  //                 <div className={styles['result-container-mobile-label']}>Remark</div>
  //               </div>
  //               <div>
  //                 <div className={styles['result-container-mobile-item']}>{data?.weightIn?.machine ?? '-'}</div>
  //                 <div className={styles['result-container-mobile-item']}>{data?.weightIn?.height ?? '-'}</div>
  //                 <div className={styles['result-container-mobile-item']}>{data?.weightIn?.weight ?? '-'}</div>
  //                 <div className={styles['result-container-mobile-item']}>{data?.weightIn?.bodyFat ?? '-'}</div>
  //                 <div className={styles['result-container-mobile-item']}>{data?.weightIn?.muscleKilogram ?? '-'}</div>
  //                 <div className={styles['result-container-mobile-item']}>
  //                   {data?.weightIn?.musclePercentage ?? '-'}
  //                 </div>
  //                 <div className={styles['result-container-mobile-item']}>{data?.weightIn?.acknowledgeBy ?? '-'}</div>
  //                 <div className={styles['result-container-mobile-item']}>
  //                   {data?.weightIn?.acknowledgeDateTime
  //                     ? formatDateDMYYYY(new Date(data?.weightIn?.acknowledgeDateTime))
  //                     : '-'}
  //                 </div>
  //                 <div className={styles['result-container-mobile-item']}>{data?.weightIn?.remarks ?? '-'}</div>
  //               </div>
  //               <div className={styles['vertical-line-mobile']}></div>
  //               <div>
  //                 <div className={styles['result-container-mobile-item']}>{data?.weightOut?.machine ?? '-'}</div>
  //                 <div className={styles['result-container-mobile-item']}>{data?.weightOut?.height ?? '-'}</div>
  //                 <div className={styles['result-container-mobile-item']}>
  //                   {data?.weightOut.weight && data.weightIn.weight ? (
  //                     <>
  //                       {data.weightOut.weight}
  //                       <span
  //                         className={styles['measurement-info-label-diff']}
  //                       >{`(${data.weightOutDiffValues.weightDiff?.toFixed(1)})`}</span>
  //                     </>
  //                   ) : (
  //                     '-'
  //                   )}
  //                 </div>
  //                 <div className={styles['result-container-mobile-item']}>
  //                   {data?.weightOut?.bodyFat && data?.weightIn?.bodyFat ? (
  //                     <>
  //                       {data?.weightOut?.bodyFat}
  //                       <span
  //                         className={styles['measurement-info-label-diff']}
  //                       >{`(${data.weightOutDiffValues.bodyFatDiff?.toFixed(1)})`}</span>
  //                     </>
  //                   ) : (
  //                     '-'
  //                   )}
  //                 </div>
  //                 <div className={styles['result-container-mobile-item']}>
  //                   {data?.weightOut?.muscleKilogram && data?.weightIn?.muscleKilogram ? (
  //                     <>
  //                       {data.weightOut.muscleKilogram}{' '}
  //                       <span
  //                         className={styles['measurement-info-label-diff']}
  //                       >{`(${data.weightOutDiffValues.muscleKilogramDiff?.toFixed(1)})`}</span>
  //                     </>
  //                   ) : (
  //                     '-'
  //                   )}
  //                 </div>
  //                 <div className={styles['result-container-mobile-item']}>
  //                   {data?.weightOut.musclePercentage && data.weightIn.musclePercentage ? (
  //                     <>
  //                       {data.weightOut.musclePercentage}
  //                       <span
  //                         className={styles['measurement-info-label-diff']}
  //                       >{`(${data.weightOutDiffValues.musclePercentageDiff?.toFixed(1)})`}</span>
  //                     </>
  //                   ) : (
  //                     '-'
  //                   )}
  //                 </div>
  //                 <div className={styles['result-container-mobile-item']}>{data?.weightOut?.acknowledgeBy ?? '-'}</div>
  //                 <div className={styles['result-container-mobile-item']}>
  //                   {data?.weightOut?.acknowledgeDateTime
  //                     ? formatDateDMYYYY(new Date(data?.weightOut?.acknowledgeDateTime))
  //                     : '-'}
  //                 </div>
  //                 <div className={styles['result-container-mobile-item']}>{data?.weightOut?.remarks ?? '-'}</div>
  //               </div>
  //             </div>
  //           </>
  //         )}
  //         {isOpen && (
  //           <Modal
  //             primaryButtonLabel={''}
  //             headline={''}
  //             closeIcon={false}
  //             containerWidth={'800px'}
  //             primaryButton={
  //               <Button
  //                 title={t('admin.participant.save')}
  //                 type={ButtonTypes.BUTTON}
  //                 onClick={() => {
  //                   handleFileUpload();
  //                 }}
  //                 size={ButtonSize.SMALL}
  //                 buttonStyle={ButtonStyles.SOLID}
  //                 data-testid="test-add-button-popup"
  //               />
  //             }
  //             secondaryButton={
  //               <Button
  //                 title={t('admin.participant.cancel')}
  //                 type={ButtonTypes.BUTTON}
  //                 onClick={handleCloseModal}
  //                 size={ButtonSize.SMALL}
  //                 buttonStyle={ButtonStyles.OUTLINE}
  //                 theme={Theme.BLACK}
  //                 data-testid="test-cancel-button-popup-delete-modal"
  //               />
  //             }
  //           >
  //             <div className={styles['modal-upload']}>
  //               {carouselType === 'before' && (
  //                 <div className={styles['before-container']}>
  //                   <div className={styles['title']}>Before</div>
  //                   <div className={styles['upload-container']}>
  //                     <div className={styles['image-container']}>
  //                       {images.before_front.url ? (
  //                         <div className={styles['image-wrapper']} style={{ position: 'relative' }}>
  //                           <img
  //                             src={images.before_front.url}
  //                             alt="Before Front View"
  //                             className={styles['uploaded-image']}
  //                           />
  //                           <div className={styles['buttons-container']}>
  //                             <button
  //                               className={styles['change-photo']}
  //                               onClick={() => document.getElementById('before_front')?.click()}
  //                             >
  //                               <img src={ChangeButton} alt="bg" />
  //                               <input
  //                                 type="file"
  //                                 id="before_front"
  //                                 accept="image/*"
  //                                 onChange={e => handleFile(e, 'before_front', true)}
  //                                 style={{ display: 'none' }}
  //                               />
  //                             </button>
  //                             <button
  //                               className={styles['remove-photo']}
  //                               onClick={() => handleRemoveImage('before', 'front')}
  //                             >
  //                               <img src={RemoveButton} alt="bg" />
  //                             </button>
  //                           </div>
  //                         </div>
  //                       ) : (
  //                         <ImageEditor onFileUpload={e => handleFileImage(e, 'front', true)} accept="image/*" />
  //                       )}
  //                       <div className={styles['label']}>Front View</div>
  //                     </div>
  //                     <div className={styles['image-container']}>
  //                       {images.before_side.url ? (
  //                         <div className={styles['image-wrapper']} style={{ position: 'relative' }}>
  //                           <img
  //                             src={images.before_side.url}
  //                             alt="Before Side View"
  //                             className={styles['uploaded-image']}
  //                           />
  //                           <div className={styles['buttons-container']}>
  //                             <button
  //                               className={styles['change-photo']}
  //                               onClick={() => document.getElementById('before_side')?.click()}
  //                             >
  //                               <img src={ChangeButton} alt="bg" />
  //                               <input
  //                                 type="file"
  //                                 id="before_side"
  //                                 accept="image/*"
  //                                 onChange={e => handleFile(e, 'before_side', true)}
  //                                 style={{ display: 'none' }}
  //                               />
  //                             </button>
  //                             <button
  //                               className={styles['remove-photo']}
  //                               onClick={() => handleRemoveImage('before', 'side')}
  //                             >
  //                               <img src={RemoveButton} alt="bg" />
  //                             </button>
  //                           </div>
  //                         </div>
  //                       ) : (
  //                         <ImageEditor onFileUpload={e => handleFileImage(e, 'side', true)} accept="image/*" />
  //                       )}
  //                       <div className={styles['label']}>Side View</div>
  //                     </div>
  //                   </div>
  //                 </div>
  //               )}
  //               {carouselType === 'after' && (
  //                 <div className={styles['before-container']}>
  //                   <div className={styles['title']}>After</div>
  //                   <div className={styles['upload-container']}>
  //                     <div className={styles['image-container']}>
  //                       {images.after_front.url ? (
  //                         <div className={styles['image-wrapper']} style={{ position: 'relative' }}>
  //                           <img
  //                             src={images.after_front.url}
  //                             alt="After Front View"
  //                             className={styles['uploaded-image']}
  //                           />
  //                           <div className={styles['buttons-container']}>
  //                             <button
  //                               className={styles['change-photo']}
  //                               onClick={() => document.getElementById('after_front')?.click()}
  //                             >
  //                               <img src={ChangeButton} alt="bg" />
  //                               <input
  //                                 type="file"
  //                                 id="after_front"
  //                                 accept="image/*"
  //                                 onChange={e => handleFile(e, 'after_front', false)}
  //                                 style={{ display: 'none' }}
  //                               />
  //                             </button>
  //                             <button
  //                               className={styles['remove-photo']}
  //                               onClick={() => handleRemoveImage('after', 'front')}
  //                             >
  //                               <img src={RemoveButton} alt="bg" />
  //                             </button>
  //                           </div>
  //                         </div>
  //                       ) : (
  //                         <ImageEditor onFileUpload={e => handleFileImage(e, 'front', false)} accept="image/*" />
  //                       )}
  //                       <div className={styles['label']}>Front View</div>
  //                     </div>
  //                     <div className={styles['image-container']}>
  //                       {images.after_side.url ? (
  //                         <div className={styles['image-wrapper']} style={{ position: 'relative' }}>
  //                           <img
  //                             src={images.after_side.url}
  //                             alt="After Side View"
  //                             className={styles['uploaded-image']}
  //                           />
  //                           <div className={styles['buttons-container']}>
  //                             <button
  //                               className={styles['change-photo']}
  //                               onClick={() => document.getElementById('after_side')?.click()}
  //                             >
  //                               <img src={ChangeButton} alt="bg" />
  //                               <input
  //                                 type="file"
  //                                 id="after_side"
  //                                 accept="image/*"
  //                                 onChange={e => handleFile(e, 'after_side', false)}
  //                                 style={{ display: 'none' }}
  //                               />
  //                             </button>
  //                             <button
  //                               className={styles['remove-photo']}
  //                               onClick={() => handleRemoveImage('after', 'side')}
  //                             >
  //                               <img src={RemoveButton} alt="bg" />
  //                             </button>
  //                           </div>
  //                         </div>
  //                       ) : (
  //                         <ImageEditor onFileUpload={e => handleFileImage(e, 'side', false)} accept="image/*" />
  //                       )}
  //                       <div className={styles['label']}>Side View</div>
  //                     </div>
  //                   </div>
  //                 </div>
  //               )}
  //             </div>
  //           </Modal>
  //         )}
  //       </Card>
  //       <Card title="Reward" classes={styles['team-profile-top-layout-3']} headerStyle={HeaderStyle.HEADER_6}>
  //         <div className={styles['rewards']}>
  //           {/* <div className={styles['rewards-campaign']}>{data?.campaign.campaignName}</div> */}
  //           {activityNames.length > 0 ? (
  //             activityNames.map((activityName, idx) => (
  //               <>
  //                 <div className={styles['rewards-event']}>
  //                   {/* {isDesktopView && (
  //                     <div className={styles['rewards-event-icon']}>
  //                       <span>Event</span>
  //                       <p>{idx + 1}</p>
  //                     </div>
  //                   )} */}
  //                   <div className={styles['rewards-event-title']}>{activityName}</div>
  //                 </div>
  //                 <div className={styles['rewards-items']}>
  //                   {data?.rewards
  //                     .filter(r => r.rewardStatus !== 'REMOVED')
  //                     .map(reward => (
  //                       <div className={styles['rewards-items-container']}>
  //                         <div className={styles['rewards-items-name']}>{reward.rewardName}</div>
  //                         <div className={styles['rewards-items-entitle']}>
  //                           <Tag
  //                             theme={reward?.redeemDate ? Theme.GRAY : Theme.SUCCESS}
  //                             style={TagStyle.OUTLINE}
  //                             text={
  //                               reward?.redeemDate
  //                                 ? `REDEEMED (${formatDateDMYYYY(new Date(reward?.redeemDate))})`
  //                                 : 'ACTIVE'
  //                             }
  //                           />
  //                         </div>
  //                       </div>
  //                     ))}
  //                 </div>
  //               </>
  //             ))
  //           ) : (
  //             <OperationCenterErrorCard errorType={ErrorType.NO_RECORD} className={styles['rewards-no-record']} />
  //           )}
  //         </div>
  //       </Card>
  //     </div>
  //     <div className={styles['team-profile-bottom']}>
  //       <Card title="Participant Progress" headerStyle={HeaderStyle.HEADER_6}>
  //         <div className={styles['progress']}>
  //           <div className={styles['team-details-container']}>
  //             <div className={styles['team-details-title-container']}>
  //               <div className={styles['team-details-title']}>Campaign: {data?.campaign.campaignName ?? '-'}</div>
  //               {isDesktopView && (
  //                 <div className={styles['team-details-coach']}>
  //                   Coach :{' '}
  //                   {data?.coachID && data?.coachName ? (
  //                     <Tag
  //                       text={`${data?.coachID} - ${data?.coachName}`}
  //                       theme={Theme.WHITE}
  //                       style={TagStyle.OUTLINE}
  //                     />
  //                   ) : (
  //                     '-'
  //                   )}
  //                 </div>
  //               )}
  //             </div>
  //             <div
  //               className={`${styles['team-details-subtitle-container']} ${styles['team-details-subtitle-container-mobile']}`}
  //             >
  //               <div className={styles['team-details-subtitle']}>{data?.team.teamName ?? '-'}</div>
  //               <Tag
  //                 text={`${data?.team.teamStartDate ? formatDateDMYYYY(new Date(data?.team.teamStartDate)) : 'N/A'} - ${
  //                   data?.team.teamEndDate ? formatDateDMYYYY(new Date(data?.team.teamEndDate)) : 'N/A'
  //                 }`}
  //                 theme={Theme.WHITE}
  //                 style={TagStyle.OUTLINE}
  //               />

  //               {/* <div className={styles['team-details-date-range']}>{`${
  //               data?.team.teamStartDate ? formatDateDMYYYY(new Date(data?.team.teamStartDate)) : 'N/A'
  //             } - ${data?.team.teamEndDate ? formatDateDMYYYY(new Date(data?.team.teamEndDate)) : 'N/A'}`}</div> */}
  //               {/* <Tag
  //               text={data?.teamStatus ?? ''}
  //               theme={data?.teamStatus === 'COMPLETED' ? Theme.SUCCESS : Theme.ERROR}
  //               style={TagStyle.OUTLINE}
  //             /> */}
  //               {/* <Tag text={'COMPLETED'} theme={Theme.SUCCESS} style={TagStyle.OUTLINE} /> */}
  //               {isDesktopView && (
  //                 <>
  //                   {props.role === 'COACH' && (
  //                     <div className={styles['team-details-collected-point']}>
  //                       Collected Points:{' '}
  //                       {(data?.points?.result ?? 0) + (data?.points?.product ?? 0) + (data?.points?.subscribe ?? 0)}
  //                     </div>
  //                   )}
  //                 </>
  //               )}
  //             </div>
  //             {!isDesktopView && (
  //               <>
  //                 <div
  //                   className={`${styles['team-details-subtitle-container']} ${styles['team-details-subtitle-container-mobile']}`}
  //                 >
  //                   <div className={styles['team-details-coach']}>Coach </div>
  //                   {data?.coachID && data?.coachName ? (
  //                     <Tag
  //                       text={`${data?.coachID} - ${data?.coachName}`}
  //                       theme={Theme.WHITE}
  //                       style={TagStyle.OUTLINE}
  //                     />
  //                   ) : (
  //                     '-'
  //                   )}
  //                 </div>
  //                 <div
  //                   className={`${styles['team-details-subtitle-container']} ${styles['team-details-subtitle-container-point']}`}
  //                 >
  //                   {props.role === 'COACH' && (
  //                     <div className={styles['team-details-collected-point']}>
  //                       Collected Points:{' '}
  //                       {(data?.points?.result ?? 0) + (data?.points?.product ?? 0) + (data?.points?.subscribe ?? 0)}
  //                     </div>
  //                   )}
  //                 </div>
  //               </>
  //             )}

  //             <div>
  //               <div className={styles['team-details-progress-card']}>
  //                 {data && (
  //                   <DetailCardProgress
  //                     {...data}
  //                     isCoachEnrollment={props.role !== 'PARTICIPANT' && data.subscribe.length === 0}
  //                     showFiveProgress={props.role !== 'PARTICIPANT'}
  //                     purchase={data?.purchase.map(p => p.orderNumber || '') || []}
  //                     subscribe={data?.subscribe.map(s => s.orderNumber || '') || []}
  //                   />
  //                 )}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </Card>
  //     </div>
  //     {confirmationPrompt}
  //     {uploadImageModal}
  //   </div>
  // );

  //#region  User Details and Health Goal

  //#region HealthGoal function
  const [healthGoalData, setHealthGoalData] = useState('');
  const [userAnswerData, setUserAnswerData] = useState<UserAnswerDataType>();
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [healthQuestionData, setHealthQuestionData] = useState<CampaignQuestionType>();
  const [addHealthGoalModal, setAddHealthGoalModal] = useState(false);

  const handleTextAreaInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setHealthGoalData(e.target.value);
  };

  const saveHealthGoal = async (deleteText: boolean = false) => {
    const selectedQuestion = healthQuestionData ? healthQuestionData : null;
    try {
      const payload = {
        userId: urlParamValue.userId,
        faqId: selectedQuestion?.questionRecId,
        answerText: deleteText ? null : healthGoalData,
        options: selectedQuestion?.options,
        campaignId: urlParamValue.campaignId,
        recId: userAnswerData?.answerId,
      };
      const response = isUpdateMode
        ? await healthGoalService.updateHealthGoal(payload)
        : await healthGoalService.addHealthGoal(payload);
      if (response.status === 200) {
        setAddHealthGoalModal(false);
        adminToast({
          message: deleteText
            ? t('Successfully deleted health goal')
            : isUpdateMode
              ? t('Successfully updated health goal')
              : t('Successfully saved health goal'),
          theme: deleteText ? Theme.WARNING : Theme.SUCCESS,
        });
        getUserAnswer();
      }
    } catch (error) {
      LoggerService.log('Error uploading data', error);
    }
  };

  const getCampaignQuestion = async () => {
    try {
      const payload = {
        campaignId: '',
      };
      const response = await healthGoalService.campaignQuestion(payload);
      setHealthQuestionData(response.data.data);
    } catch (error) {
      LoggerService.log('Error retrieving question', error);
    }
  };

  const getUserAnswer = async () => {
    try {
      const payload = {
        userId: urlParamValue.userId,
        campaignId: urlParamValue.campaignId,
      };
      const response = await healthGoalService.userAnswer(payload);
      if (response.status === 200) {
        setUserAnswerData(response.data.data);
        if (response.data.data !== null) {
          setHealthGoalData(response.data.data.answerText);
          setIsUpdateMode(true);
        }
      }
    } catch (error) {
      LoggerService.log('Error retrieving question', error);
    }
  };

  //#endregion

  //#region UserFunction
  const RoleList = (): string => {
    // LoggerService.log(role);
    // if (role === 'PARTICIPANT') return 'Participant';
    // if (role === 'COACH') return 'Coach';
    // if (role === 'LEADER') return 'Leader';
    // return '-';

    return 'Participant';
  };

  const handleProfileFileImage = (e: customEventPropType, view: string) => {
    const file = e.files[0];
    setProfileImageFile(file);
    const objectUrl = URL.createObjectURL(file);
    setProfileImageUrl(objectUrl);
    setShowModal(false);
  };
  const handleProfileFile = (e: ChangeEvent<HTMLInputElement>, key: string) => {
    const file = e.target.files?.[0] as File | null;

    setProfileImageFile(file);
    if (file) {
      const objectUrl = URL.createObjectURL(file);
      setProfileImageUrl(objectUrl);
    } else {
      setProfileImageUrl('');
    }
    setShowModal(false);
  };

  // const handleFile = (e: ChangeEvent<HTMLInputElement>, key: string, isBefore: boolean) => {
  //   const file = e.target.files?.[0] as File | null;
  //   if (file) {
  //     const url: string = URL.createObjectURL(file);
  //     setImages(prevImages => ({
  //       ...prevImages,
  //       [key]: { ...prevImages[key], file, url },
  //     }));
  //   }
  // };

  const deleteProfile = async () => {
    const payload = {
      loginId: urlParamValue?.userId,
    };
    const deleteProfileResponse = await apiCall(AttachmentService.removeProfile, payload);

    if (deleteProfileResponse.status === 200) {
      setProfileImageUrl('');
    }
  };

  const fetchProfileImage = async () => {
    try {
      const response = await AttachmentService.downloadProfileImage(urlParamValue?.userId ?? '');
      if (response.data && response.data.data && response.data.data.image) {
        setProfileImageUrl(response.data.data.image);
      }
    } catch (error) {
      LoggerService.log('Error downloading image', error);
    }
  };

  const handleProfileUpload = async () => {
    try {
      if (profileImageFile && urlParamValue?.userId) {
        const formData = processProfilePictureData(profileImageFile, urlParamValue?.userId);
        const response = await apiCall(() => AttachmentService.postUploadProfile(formData));
        if (response.status === 200) {
          LoggerService.log('Successfully upload image', response);
        }
      }
    } catch (error) {
      LoggerService.log('Error upload image', error);
    }
  };

  const handleOnChange = (value: DynamicObjectInterface, key: 'input' | 'check') => {
    setAlpValue(prev => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  // const getButtonConfig = useMemo(() => {
  //   let commonConfig = {
  //     iconName: 'pencil' as IconName,
  //     iconStyle: IconStyle.SOLID,
  //     theme: Theme.WHITE,
  //     title: t('admin.participant.edit'),
  //   };

  //   if (props.role === 'COACH' || props.role === 'LEADER') {
  //     if ((data?.subscribe ?? [])?.length > 0 && data?.subscribe[0].orderNumber !== null) {
  //       return {
  //         alp: [{ ...commonConfig, onClick: () => setShowConfirmation(true) }],
  //       } as { [index: string]: IconButtonProps[] };
  //     } else {
  //       return {
  //         alp: [
  //           {
  //             // title: isDesktopView ? 'Order No.' : 'ALP Order No.',
  //             title: 'ALP Order No.',
  //             icon: {
  //               iconName: 'square-plus',
  //               iconStyle: IconStyle.REGULAR,
  //             } as IconPropInterface,
  //             iconPosition: ButtonIconPosition.LEFT,
  //             buttonStyle: ButtonStyles.OUTLINE,
  //             theme: Theme.PURPLE,
  //             size: isDesktopView ? ButtonSize.SMALL : ButtonSize.EXTRA_SMALL,
  //             onClick: () => {
  //               setShowConfirmation(true);
  //             },
  //           },
  //         ],
  //       } as { [index: string]: ButtonPropsTypes[] };
  //     }
  //   } else {
  //     return {};
  //   }
  // }, [data]);

  const onSave = async () => {
    let payload = {
      campaignId: urlParamValue?.campaignId,
      teamId: urlParamValue?.teamId,
      allocation: {
        alp: {
          invoices: [
            {
              recId: data?.subscribe[0]?.recId || null,
              orderPoint: 1,
              orderNumber: alpValue.input,
            },
          ],
          point: data?.point?.subscribe ?? 0,
          pointAdj: data?.point?.subscribeAdj ?? 0,
        },
      },
    };

    const result = await apiCall(
      ParticipantService.updateParticipantDetails,
      {
        ...payload,
        section: 'pointAllocation',
      },
      urlParamValue?.userId,
    );

    if (result.status === 200) {
      adminToast({
        message: t('admin.participant.updateSuccess'),
        theme: Theme.SUCCESS,
      });
      fetchData();
      setShowConfirmation(false);
    } else {
      adminToast({
        message: t('admin.participant.updateFail'),
        theme: Theme.ERROR,
      });
    }
  };

  const showModalFn = () => {
    setShowModal(true);
  };
  //#endregion

  useEffect(() => {
    getCampaignQuestion();
    getUserAnswer();
  }, []);

  useEffect(() => {
    fetchProfileImage();
  }, []);

  useEffect(() => {
    if (profileImageFile !== null) {
      handleProfileUpload();
    }
  }, [profileImageFile]);

  const healthGoalModal = (
    <>
      {addHealthGoalModal &&
        (isDesktopView ? (
          <Modal
            primaryButtonLabel={''}
            headline={
              <div className={styles['progress-monitoring-title-container']}>
                <div className={styles['progress-monitoring-title-container-title']}>Health Goal</div>
                <div className={styles['progress-monitoring-title-container-subtitle']}>(Optional)</div>
                <Tooltip
                  message={'Your health goal(s) during this campaign period'}
                  preference={TooltipPreference.RIGHT}
                  className={styles['input-tool-tip']}
                />
              </div>
            }
            children={
              <>
                <TextArea
                  mlpVersion={MLPVersion.ONE}
                  placeholder={t('Describe your health goal.   \nE.g: I want to lose 5 kg in 3 months')}
                  resize={false}
                  value={healthGoalData}
                  onChange={handleTextAreaInput}
                />
              </>
            }
            closeIcon={false}
            containerWidth={'398px'}
            textAlign={TextAlign.LEFT}
            buttonHorizontalAlignment={TextAlign.RIGHT}
            primaryButton={
              <Button
                title="Save goals"
                type={ButtonTypes.BUTTON}
                onClick={() => {
                  saveHealthGoal();
                }}
                size={ButtonSize.MEDIUM}
                buttonStyle={ButtonStyles.SOLID}
              />
            }
            secondaryButton={
              <Button
                title="Cancel"
                type={ButtonTypes.BUTTON}
                onClick={() => {
                  setAddHealthGoalModal(false);
                }}
                size={ButtonSize.MEDIUM}
                buttonStyle={ButtonStyles.OUTLINE}
                data-testid="test-cancel-button-popup-delete-modal"
              />
            }
          />
        ) : (
          <Drawer
            onClose={() => setAddHealthGoalModal(false)}
            header={'Add New Goals'}
            className={styles['mobile-drawer']}
            closeOnBackdropClick={true}
            // closeIcon={true}
            bottomGap={0}
            footer={
              <div className={styles['drawer-buttons']}>
                <Button
                  title="Cancel"
                  type={ButtonTypes.BUTTON}
                  onClick={() => {
                    setAddHealthGoalModal(false);
                  }}
                  size={ButtonSize.MEDIUM}
                  buttonWidth={ButtonWidth.FULL_WIDTH}
                  buttonStyle={ButtonStyles.OUTLINE}
                  className={styles['button-cancel']}
                />
                <Button
                  title="Save"
                  type={ButtonTypes.BUTTON}
                  onClick={() => {
                    saveHealthGoal();
                  }}
                  buttonWidth={ButtonWidth.FULL_WIDTH}
                  size={ButtonSize.MEDIUM}
                  buttonStyle={ButtonStyles.SOLID}
                />
              </div>
            }
          >
            <div className={styles['text-area-mobile']}>
              <TextArea
                mlpVersion={MLPVersion.ONE}
                placeholder={t('Describe your health goal.   \nE.g: I want to lose 5 kg in 3 months')}
                resize={false}
                value={healthGoalData}
                className={styles['text-area-mobile-input']}
                onChange={handleTextAreaInput}
              />
            </div>
          </Drawer>
        ))}
    </>
  );

  const confirmationPrompt = (
    <>
      {showConfirmation && (
        <Modal
          primaryButtonLabel={''}
          headline={'Add SOP Subscription Order Number'}
          children={
            <>
              <div
                style={{
                  fontSize: '16px',
                  fontFamily: 'GT-Walsheim-Pro-Bold, sans-serif',
                  lineHeight: '24px',
                  margin: '10px 0',
                }}
              >
                Enter your SOP Subscription Order Number
              </div>
              <Input
                type={InputTypes.TEXT}
                name={'orderNumber'}
                label={t('admin.participant.alpInvoiceNumber')}
                value={alpValue.input}
                mlpVersion={MLPVersion.ONE}
                onChange={e => handleOnChange(e.target.value || null, 'input')}
              />
              <div style={{ display: 'flex', margin: '32px 0' }}>
                <Checkbox
                  key={'checkbox'}
                  className={styles['checkbox']}
                  checked={alpValue.check}
                  theme={Theme.BLACK}
                  text={
                    <p
                      id="agree-checkbox"
                      dangerouslySetInnerHTML={{
                        __html: t('admin.teamCreate.termsLine1').replace(
                          '{terms-conditions}',
                          `<a href="/terms-and-conditions?cid=${urlParamValue?.campaignId}" target="_blank">${t('securityPrivacy.terms-condition')}</a>`,
                        ),
                      }}
                    />
                  }
                  onChange={e => handleOnChange(alpValue.check ? !alpValue.check : true, 'check')} //handleOnChange(e.target.value === 'on', 'check')}
                />
                <>
                  {/* {t('admin.teamCreate.termsLine1')} */}
                  <br />
                  {/* {t('admin.teamCreate.termsLine2')} */}
                </>
              </div>
            </>
          }
          closeIcon={false}
          containerWidth={'max-content'}
          textAlign={TextAlign.LEFT}
          primaryButton={
            <Button
              title="Confirm"
              type={ButtonTypes.BUTTON}
              onClick={() => {
                onSave();
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
              disabled={!alpValue.check}
            />
          }
          secondaryButton={
            <Button
              title="Cancel"
              type={ButtonTypes.BUTTON}
              onClick={() => {
                setAlpValue({ input: data?.subscribe?.map(i => i.orderNumber)?.join(', ') ?? '', check: false });
                setData(data);
                setShowConfirmation(false);
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.OUTLINE}
              data-testid="test-cancel-button-popup-delete-modal"
            />
          }
        />
      )}
    </>
  );

  const uploadImageModal = (
    <>
      {showModal && (
        <Modal
          primaryButtonLabel={''}
          headline={'Upload your Profile Picture'}
          containerWidth={'600px'}
          containerHeight={'600px'}
          closeIcon={true}
          onClose={() => setShowModal(false)}
        >
          <div>
            {profileImageUrl ? (
              <div className={styles['profile-image-container']}>
                <div className={styles['image-wrapper']}>
                  <img
                    src={profileImageUrl}
                    alt="Before Front View"
                    className={styles['profile-image']}
                    style={{ borderRadius: '50%' }}
                  />
                </div>
                <div className={styles['buttons-container']}>
                  <button
                    className={styles['change-photo']}
                    onClick={() => document.getElementById('profileImageUrl')?.click()}
                  >
                    <img src={ChangeButton} alt="bg" />
                    <input
                      type="file"
                      id="profileImageUrl"
                      accept="image/*"
                      onChange={e => handleProfileFile(e, 'profileImageUrl')}
                      style={{ display: 'none' }}
                    />
                  </button>
                  <button className={styles['remove-photo']} onClick={() => deleteProfile()}>
                    <img src={RemoveButton} alt="bg" />
                  </button>
                </div>
              </div>
            ) : (
              <ImageEditor onFileUpload={e => handleProfileFileImage(e, 'file')} accept="image/*" />
            )}
          </div>
        </Modal>
      )}
    </>
  );

  const userDetails = (
    <Card containerHeight="100%" classes={styles['team-usr-profile-no-padding']}>
      {/* campaign details section */}
      <div className={styles['team-usr-profile']}>
        {isDesktopView ? (
          <>
            <div className={styles['team-usr-profile-img-content']}>
              <div className={styles['team-usr-profile-img-separator']}>
                <div className={styles['team-usr-profile-img-container']}>
                  <img
                    src={profileImageUrl ? profileImageUrl : personalizeImg}
                    alt="personalize"
                    onClick={props.decodedData.name === data?.name ? showModalFn : undefined}
                    className={styles['team-usr-profile-image']}
                  />
                </div>
                {data?.isTeamLeader && (
                  <div
                    className={`${styles['team-usr-profile-img-content-team-leader']} ${styles['team-usr-profile-img-content-tag']}`}
                  >
                    {'Team Leader'.toLocaleUpperCase()}
                  </div>
                )}
              </div>
              {data?.isNewAbo === 1 && (
                <div
                  className={`${styles['team-usr-profile-img-content-new-abo']} ${styles['team-usr-profile-img-content-tag']}`}
                >
                  {'new abo'.toLocaleUpperCase()}
                </div>
              )}
            </div>
            <div className={styles['team-usr-profile-details-info']}>
              <div className={styles['team-usr-profile-details-info-pre-header']}>
                <div className={styles['team-usr-profile-details-info-blank']}></div>
                <div className={styles['team-usr-profile-details-info-header']}>{t('Team Member Profile')}</div>
              </div>
              <div className={styles['team-usr-profile-container']}>
                <div className={styles['team-usr-profile-details-info-blank']}></div>
                <div className={styles['team-usr-profile-pre-content']}>
                  <div className={styles['team-usr-profile-content']}>
                    <div className={styles['team-usr-profile-content-info-first']}>
                      <div className={styles['team-usr-profile-content-label']}>Name</div>
                      <div className={`${styles['team-usr-profile-content-tag']}`}>{data?.name}</div>
                    </div>
                    <div className={styles['team-usr-profile-content-info-second']}>
                      <div className={styles['team-usr-profile-content-label']}>Contact No.</div>
                      <div className={`${styles['team-usr-profile-content-tag']}`}>{data?.phone}</div>
                    </div>
                  </div>
                  <div className={styles['team-usr-profile-content-full-width']}>
                    <div className={styles['team-usr-profile-content-info-first']}>
                      <div className={styles['team-usr-profile-content-label']}>ABO No.</div>
                      <div className={`${styles['team-usr-profile-content-tag']}`}>{data?.loginId}</div>
                    </div>
                    <div className={styles['team-usr-profile-content-info-second']}>
                      <div className={styles['team-usr-profile-content-label']}>Email</div>
                      <div className={`${styles['team-usr-profile-content-tag']} ${styles['email']}`}>
                        {data?.email ?? '-'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={styles['team-usr-profile-img-content']}>
              <div className={styles['team-usr-profile-img-separator']}>
                <div className={styles['team-usr-profile-img-container']}>
                  <img
                    src={profileImageUrl ? profileImageUrl : personalizeImg}
                    alt="personalize"
                    onClick={props.decodedData.name === data?.name ? showModalFn : undefined}
                    className={styles['team-usr-profile-image']}
                  />
                </div>
                {data?.isTeamLeader && (
                  <div
                    className={`${styles['team-usr-profile-img-content-team-leader']} ${styles['team-usr-profile-img-content-tag']}`}
                  >
                    {'Team Leader'.toLocaleUpperCase()}
                  </div>
                )}
              </div>
              {data?.isNewAbo === 1 && (
                <div
                  className={`${styles['team-usr-profile-img-content-new-abo']} ${styles['team-usr-profile-img-content-tag']}`}
                >
                  {'new abo'.toLocaleUpperCase()}
                </div>
              )}
            </div>
            <div className={styles['team-usr-profile-details-info']}>
              <div className={styles['team-usr-profile-details-info-pre-header']}>
                <div className={styles['team-usr-profile-details-info-blank']}></div>
                <div className={styles['team-usr-profile-details-info-header']}>{t('Team Member Profile')}</div>
              </div>
              <div className={styles['team-usr-profile-container']}>
                <div className={styles['team-usr-profile-details-info-blank']}></div>
                <div className={styles['team-usr-profile-pre-content']}>
                  <div className={styles['team-usr-profile-content']}>
                    <div className={styles['team-usr-profile-content-info-first']}>
                      <div className={styles['team-usr-profile-content-label']}>Name</div>
                      <div className={`${styles['team-usr-profile-content-tag']}`}>{data?.name}</div>
                    </div>
                    <div className={styles['team-usr-profile-content-info-second']}>
                      <div className={styles['team-usr-profile-content-label']}>ABO No.</div>
                      <div className={`${styles['team-usr-profile-content-tag']}`}>{data?.loginId}</div>
                    </div>
                  </div>
                  <div className={styles['team-usr-profile-content-full-width']}>
                    <div className={styles['team-usr-profile-content-info-first']}>
                      <div className={styles['team-usr-profile-content-label']}>Contact No.</div>
                      <div className={`${styles['team-usr-profile-content-tag']}`}>{data?.phone}</div>
                    </div>
                    <div className={styles['team-usr-profile-content-info-second']}>
                      <div className={styles['team-usr-profile-content-label']}>Email</div>
                      <div className={`${styles['team-usr-profile-content-tag']} ${styles['email']}`}>
                        {data?.email ?? '-'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className={styles['team-usr-profile-role']}>
        <div className={styles['team-usr-profile-role-label']}>{t('Role')}</div>
        <div className={styles['team-usr-profile-role-tag']}>{RoleList()}</div>
      </div>
      {userAnswerData?.answerText !== undefined && userAnswerData?.answerText !== null && (
        <div className={styles['progress-monitoring-horizontal-line']} />
      )}
      {/* health goal section  */}
      {userAnswerData?.answerText !== undefined && userAnswerData?.answerText !== null ? (
        <div>
          <div className={styles['progress-monitoring-title-container']}>
            <div className={styles['progress-monitoring-title-container-title']}>Health Goal</div>
            <div className={styles['progress-monitoring-title-container-subtitle']}>(Optional)</div>
            <Tooltip
              message={
                'Health goals are optional and are intended for your personal records to help you stay focused throughout the journey.'
              }
              preference={TooltipPreference.RIGHT}
              className={styles['input-tool-tip']}
            />
          </div>
          <div className={styles['health-goal-section']}>
            <div className={styles['health-goal-content']}>{userAnswerData?.answerText}</div>
          </div>
        </div>
      ) : null}
      {healthGoalModal}
    </Card>
  );
  //#endregion

  //#region Measurement and Progress
  const [progressData, setProgressData] = useState<ProgressType[]>([]);

  const fetchMeasurementImage = async () => {
    try {
      const payload = {
        campaignId: urlParamValue?.campaignId,
        teamId: urlParamValue?.teamId,
        loginId: urlParamValue?.userId,
      };
      const response = await AttachmentService.downloadBeforeAfter(payload);

      // Validate response structure
      const imageData = response?.data?.data?.image || [];

      // Update state variables based on the downloaded image data
      const updatedImages = { ...images };

      imageData.forEach((image: { photoId: number; photoType: string; url: string }) => {
        const { photoId, photoType, url } = image;
        if (Object.prototype.hasOwnProperty.call(updatedImages, photoType)) {
          updatedImages[photoType].url = url;
          updatedImages[photoType].photoId = photoId; // Assigning index from API response
        }
      });

      setImages(updatedImages);
    } catch (error) {
      LoggerService.log('Error downloading image', error);
    }
  };

  const fetchProgressMonitoringList = async () => {
    const info = {
      loginId: data?.loginId,
      userId: urlParamValue.userId,
      campaignId: urlParamValue?.campaignId,
    };

    try {
      const result = await apiCall(intermediateMeasurementService.getIntermediateMeasurementList, info);
      setProgressData(result?.data?.data);
    } catch (error) {
      LoggerService.log('Failed to retrieve campaign list', error);
    }
  };

  // const handleImageUpload = (type: string) => {
  //   setIsOpen(true);
  //   setCarouselType(type);
  // };

  // const handleCloseModal = () => {
  //   setIsOpen(false); // Close the modal
  // };

  // const handleFileImage = (e: customEventPropType, view: string, isBefore: boolean) => {
  //   const file = e.files[0];
  //   const imageUrlSetter = isBefore ? 'before' : 'after';
  //   const imageStateSetter = view === 'front' ? 'front' : 'side';

  //   // Check if the original filename is "image.jpg"
  //   const originalFileName = file.name;
  //   const isOriginalImageName = originalFileName === 'image.jpg';

  //   // Get current date and time to create a unique filename
  //   const currentDate = new Date();
  //   const timestamp = currentDate.getTime(); // Get timestamp in milliseconds
  //   const extension = file.name.split('.').pop(); // Get the file extension

  //   let newFileName = originalFileName; // Default to original filename
  //   if (isOriginalImageName) {
  //     newFileName = `${timestamp}.${extension}`; // Create new filename with timestamp
  //   }

  //   setImages((prevImages: Record<string, AttachmentImageBA>) => ({
  //     ...prevImages,
  //     [`${imageUrlSetter}_${imageStateSetter}`]: {
  //       photoId: prevImages[`${imageUrlSetter}_${imageStateSetter}`].photoId,
  //       url: URL.createObjectURL(file),
  //       file: new File([file], newFileName), // Create a new File object with the renamed file if needed
  //     },
  //   }));
  // };

  // const handleRemoveImage = (imageUrlSetter: string, imageStateSetter: string) => {
  //   setImages((prevImages: Record<string, AttachmentImageBA>) => ({
  //     ...prevImages,
  //     [`${imageUrlSetter}_${imageStateSetter}`]: {
  //       photoId: prevImages[`${imageUrlSetter}_${imageStateSetter}`].photoId,
  //       url: '',
  //       file: null,
  //     },
  //   }));
  // };

  // const handleFileUpload = async () => {
  //   try {
  //     const formData = processBeforeAfterImagesData(
  //       images,
  //       urlParamValue?.campaignId,
  //       urlParamValue.teamId,
  //       urlParamValue?.userId,
  //     );
  //     const response = await apiCall(() => AttachmentService.postUploadBeforeAfter(formData));

  //     if (response.status === 200) {
  //       const newImages = processBeforeAfterImagesResponse(response, images);
  //       setImages({ ...newImages });
  //       handleCloseModal();
  //       LoggerService.log('Successfully uploading image', response);
  //     }
  //   } catch (error) {
  //     LoggerService.log('Error uploading image', error);
  //   }
  // };

  const progressMonitorConfig: GetColumnsType = (styles: Object, translation: Function, cb: DynamicObjectInterface) => [
    {
      key: 'weighingDate',
      text: 'Date',
      sortable: true,
      width: 25,
      render: (object: DynamicObjectInterface) => {
        return <span>{dateTimeToCustomFormat(object.weighingDate, 'DD/MM/YYYY')}</span>;
      },
    },
    {
      key: 'weight',
      text: 'Weight (kg)',
      sortable: false,
      width: 20,
      render: (object: DynamicObjectInterface) => (
        <span>{getRoundedNumber(parseFloat(decryptString(object.weight)))}</span>
      ),
    },
    {
      key: 'bodyFat',
      text: 'Body fat (%)',
      sortable: false,
      width: 20,
      render: (object: DynamicObjectInterface) => (
        <span>{getRoundedNumber(parseFloat(decryptString(object.bodyFat)))}</span>
      ),
    },
    {
      key: 'muscleKilogram',
      text: 'Muscle Mass (kg)',
      sortable: false,
      width: 20,
      render: (object: DynamicObjectInterface) => (
        <span>{getRoundedNumber(parseFloat(decryptString(object.muscleKilogram)))}</span>
      ),
    },
  ];

  useEffect(() => {
    fetchMeasurementImage();
  }, []);

  useEffect(() => {
    fetchProgressMonitoringList();
  }, [data]);

  const measurementDetail = (
    <Card
      title={t('admin.dashboard.measurement')}
      headerStyle={isDesktopView ? HeaderStyle.HEADER_5 : HeaderStyle.HEADER_6}
      // buttonType={ButtonType.ICON}
      // button={getButtonConfig.alp}
      // buttonLabel={getButtonLabelConfig}
    >
      {isDesktopView ? (
        <div className={styles['result-container']}>
          <div className={styles['measurement-wrap']}>
            <div className={styles['carousel-container']}>
              <ImageSlider
                id="beforeImg"
                slides={[
                  {
                    src: images.before_front.url ? images.before_front.url : PhotoUnavailable,
                    alt: 'Before Front View',
                  },
                  {
                    src: images.before_side.url ? images.before_side.url : PhotoUnavailable,
                    alt: 'Before Side View',
                  },
                ]}
                // onClick={() => handleImageUpload('before')}
              />
              {/* <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.remark')}</div>
                <p>{data?.weightIn?.remarks ?? '-'}</p>
              </div> */}
            </div>
            <div className={styles['result-info']}>
              <div className={styles['title']}>{t('admin.participant.before')}</div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.weighInDate')}</div>
                {/* <div className={styles['tag-calendar']}> */}
                <div className={styles['tag-calendar']}>
                  {data?.weightIn?.weightedDate ? (
                    <Tag
                      theme={Theme.GRAY}
                      text={dateTimeToCustomFormat(data?.weightIn?.weightedDate ?? '', 'DD/MM/yyyy')}
                      style={TagStyle.OUTLINE}
                    />
                  ) : (
                    '-'
                  )}
                </div>
              </div>
              {/* </div> */}
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.machine')}</div>
                <p>{data?.weightIn?.machine ?? '-'}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.height')}</div>
                <p>{data?.weightIn?.height ?? '-'}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.weight')}</div>
                <p>{data?.weightIn?.weight}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.muscleMassKg')}</div>
                <p>{data?.weightIn?.muscleKilogram}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.muscleMassPercentage')}</div>
                <p>{data?.weightIn?.musclePercentage}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.bodyFatPercentage')}</div>
                <p>{data?.weightIn?.bodyFat}</p>
              </div>
              <div className={styles['acknowledge-container']}>
                <div className={styles['label-container']}>
                  <div className={styles['label-small']}>{t('admin.participant.acknowledgedBy')}</div>
                  <p className={styles['label-small-ans']}>{data?.weightIn?.acknowledgeByName ?? '-'}</p>
                </div>

                <div className={styles['label-container-ack']}>
                  <div className={styles['label-ack-small']}>{t('admin.participant.acknowledgedDate')}</div>
                  <p className={styles['label-ack-small-ans']}>
                    {data?.weightIn?.acknowledgeDateTime
                      ? dateTimeToCustomFormat(data?.weightIn.acknowledgeDateTime ?? '', 'DD/MM/yyyy')
                      : '-'}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={styles['measurement-wrap']}>
            <div className={styles['carousel-container']}>
              <ImageSlider
                id="afterImg"
                slides={[
                  {
                    src: images.after_front.url ? images.after_front.url : PhotoUnavailable,
                    alt: 'After Front View',
                  },
                  {
                    src: images.after_side.url ? images.after_side.url : PhotoUnavailable,
                    alt: 'Afer Side View',
                  },
                ]}
                // onClick={() => handleImageUpload('after')}
              />
              {/* <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.remark')}</div>
                <p>{data?.weightOut?.remarks ?? '-'}</p>
              </div> */}
            </div>
            <div className={styles['result-info']}>
              <div className={styles['title']}>{t('admin.participant.after')}</div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.weighOutDate')}</div>
                <div className={styles['tag-calendar']}>
                  {data?.weightOut?.weightedDate ? (
                    <Tag
                      theme={Theme.GRAY}
                      text={dateTimeToCustomFormat(data?.weightOut?.weightedDate ?? '', 'DD/MM/yyyy')}
                      style={TagStyle.OUTLINE}
                    />
                  ) : (
                    '-'
                  )}
                </div>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.machine')}</div>
                <p>{data?.weightOut?.machine ?? '-'}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.height')}</div>
                <p>{data?.weightOut?.height ?? '-'}</p>
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.weight')}</div>
                <p>{data?.weightOut?.weight}</p>
                {data?.weightOutDiffValues?.weightDiff && data?.weightOut?.weightedDate ? (
                  <div
                    className={`${styles['difference-label']} ${
                      data?.weightOutDiffValues?.weightDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.weightDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.weightDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.weightDiff?.toFixed(1)})
                  </div>
                ) : null}
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.muscleMassKg')}</div>
                <p>{data?.weightOut?.muscleKilogram}</p>
                {data?.weightOutDiffValues?.muscleKilogramDiff && data?.weightOut?.weightedDate ? (
                  <div
                    className={`${styles['difference-label-alt']} ${
                      data?.weightOutDiffValues?.muscleKilogramDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.muscleKilogramDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.muscleKilogramDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.muscleKilogramDiff?.toFixed(1)})
                  </div>
                ) : null}
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.muscleMassPercentage')}</div>
                <p>{data?.weightOut?.musclePercentage}</p>
                {data?.weightOutDiffValues?.musclePercentageDiff && data?.weightOut?.weightedDate ? (
                  <div
                    className={`${styles['difference-label-alt']} ${
                      data?.weightOutDiffValues?.musclePercentageDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.musclePercentageDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.musclePercentageDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.musclePercentageDiff?.toFixed(1)})
                  </div>
                ) : null}
              </div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.bodyFatPercentage')}</div>
                <p>{data?.weightOut?.bodyFat}</p>
                {data?.weightOutDiffValues?.bodyFatDiff && data?.weightOut?.weightedDate ? (
                  <div
                    className={`${styles['difference-label']} ${
                      data?.weightOutDiffValues?.bodyFatDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.bodyFatDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.bodyFatDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.bodyFatDiff?.toFixed(1)})
                  </div>
                ) : null}
              </div>
              <div className={styles['acknowledge-container']}>
                <div className={styles['label-container']}>
                  <div className={styles['label-small']}>{t('admin.participant.acknowledgedBy')}</div>
                  <p className={styles['label-small-ans']}>{data?.weightOut?.acknowledgeByName ?? '-'}</p>
                </div>

                <div className={styles['label-container-ack']}>
                  <div className={styles['label-ack-small']}>{t('admin.participant.acknowledgedDate')}</div>
                  <p className={styles['label-ack-small-ans']}>
                    {data?.weightOut?.acknowledgeDateTime
                      ? dateTimeToCustomFormat(data?.weightOut.acknowledgeDateTime ?? '', 'DD/MM/yyyy')
                      : '-'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className={styles['result-container-mobile']}>
            <div></div>
            <div className={styles['result-container-mobile-wrapper']}>
              <div className={styles['carousel-container']}>
                <ImageSlider
                  id="beforeImg"
                  slides={[
                    {
                      src: images.before_front.url ? images.before_front.url : PhotoUnavailable,
                      alt: 'Before Front View',
                    },
                    {
                      src: images.before_side.url ? images.before_side.url : PhotoUnavailable,
                      alt: 'Before Side View',
                    },
                  ]}
                  // onClick={() => handleImageUpload('before')}
                />
              </div>
              <div className={styles['result-container-mobile-title']}>Before</div>
            </div>
            <div></div>
            <div className={styles['result-container-mobile-wrapper']}>
              <div className={styles['carousel-container']}>
                <ImageSlider
                  id="afterImg"
                  slides={[
                    {
                      src: images.after_front.url ? images.after_front.url : PhotoUnavailable,
                      alt: 'After Front View',
                    },
                    {
                      src: images.after_side.url ? images.after_side.url : PhotoUnavailable,
                      alt: 'After Side View',
                    },
                  ]}
                  // onClick={() => handleImageUpload('after')}
                />
              </div>
              <div className={styles['result-container-mobile-title']}>After</div>
            </div>
          </div>
          <div className={styles['result-container-mobile']}>
            <div></div>
            <div className={styles['result-container-mobile-wrapper']}>
              <div className={styles['result-container-mobile-header-label']}>Pre-Assessment Date:</div>
              <div className={`${styles['tag-calendar']} ${styles['result-container-mobile-date']}`}>
                {data?.weightIn?.weightedDate ? (
                  <Tag
                    theme={Theme.GRAY}
                    text={dateTimeToCustomFormat(data?.weightIn?.weightedDate ?? '', 'DD/MM/yyyy')}
                    style={TagStyle.OUTLINE}
                  />
                ) : (
                  '-'
                )}
              </div>
            </div>
            <div className={styles['vertical-line-mobile']}></div>
            <div className={styles['result-container-mobile-wrapper']}>
              <div className={styles['result-container-mobile-header-label']}>Post-Assessment Date:</div>
              <div className={styles['tag-calendar']}>
                {data?.weightOut?.weightedDate ? (
                  <Tag
                    theme={Theme.GRAY}
                    text={dateTimeToCustomFormat(data?.weightOut?.weightedDate ?? '', 'DD/MM/yyyy')}
                    style={TagStyle.OUTLINE}
                  />
                ) : (
                  '-'
                )}
              </div>
            </div>
          </div>
          <div className={styles['result-container-mobile']}>
            <div>
              <div className={styles['result-container-mobile-label']}>Machine</div>
              <div className={styles['result-container-mobile-label']}>Height (cm)</div>
              <div className={styles['result-container-mobile-label']}>Weight (kg)</div>
              <div className={styles['result-container-mobile-label']}>Body Fat (%)</div>
              <div className={styles['result-container-mobile-label']}>Muscle Mass (kg)</div>
              <div className={styles['result-container-mobile-label']}>Muscle Mass (%)</div>

              {/* <div className={styles['result-container-mobile-label']}>Remark</div> */}
            </div>
            <div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.machine ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.height ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.weight ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.bodyFat ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.muscleKilogram ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.musclePercentage ?? '-'}</div>

              {/* <div className={styles['result-container-mobile-item']}>{data?.weightIn?.remarks ?? '-'}</div> */}
            </div>
            <div className={styles['vertical-line-mobile']}></div>
            <div>
              <div className={styles['result-container-mobile-item']}>{data?.weightOut?.machine ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightOut?.height ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>
                {data?.weightOut?.weight ?? '-'}
                {data?.weightOutDiffValues?.weightDiff && data?.weightOut?.weightedDate ? (
                  <span
                    className={`${styles['difference-label']} ${
                      data?.weightOutDiffValues?.weightDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.weightDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.weightDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.weightDiff?.toFixed(1)})
                  </span>
                ) : null}
              </div>
              <div className={styles['result-container-mobile-item']}>
                {data?.weightOut?.bodyFat ?? '-'}
                {data?.weightOutDiffValues?.bodyFatDiff && data?.weightOut?.weightedDate ? (
                  <span
                    className={`${styles['difference-label']} ${
                      data?.weightOutDiffValues?.bodyFatDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.bodyFatDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.bodyFatDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.bodyFatDiff?.toFixed(1)})
                  </span>
                ) : null}
              </div>
              <div className={styles['result-container-mobile-item']}>
                {data?.weightOut?.muscleKilogram ?? '-'}
                {data?.weightOutDiffValues?.muscleKilogramDiff && data?.weightOut?.weightedDate ? (
                  <span
                    className={`${styles['difference-label-alt']} ${
                      data?.weightOutDiffValues?.muscleKilogramDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.muscleKilogramDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.muscleKilogramDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.muscleKilogramDiff?.toFixed(1)})
                  </span>
                ) : null}
              </div>
              <div className={styles['result-container-mobile-item']}>
                {data?.weightOut?.musclePercentage ?? '-'}
                {data?.weightOutDiffValues?.musclePercentageDiff && data?.weightOut?.weightedDate ? (
                  <span
                    className={`${styles['difference-label-alt']} ${
                      data?.weightOutDiffValues?.musclePercentageDiff > 0
                        ? styles.positive
                        : data?.weightOutDiffValues?.musclePercentageDiff === 0
                          ? styles.zero
                          : styles.negative
                    }`}
                  >
                    ({data?.weightOutDiffValues?.musclePercentageDiff > 0 ? '+' : ''}
                    {data?.weightOutDiffValues?.musclePercentageDiff?.toFixed(1)})
                  </span>
                ) : null}
              </div>

              {/* <div className={styles['result-container-mobile-item']}>{data?.weightOut?.remarks ?? '-'}</div> */}
            </div>
          </div>
          <div className={styles['acknowledge-container-mobile']}>
            <div className={styles['acknowledge-container-mobile-date']}>
              <div className={styles['result-container-mobile-label']}>Acknowledgement Date</div>
              <div className={styles['result-container-mobile-item']}>
                {data?.weightIn?.acknowledgeDateTime
                  ? formatDateDMYYYY(new Date(data?.weightIn?.acknowledgeDateTime))
                  : '-'}
              </div>
              <div className={styles['result-container-mobile-item']}>
                {data?.weightOut?.acknowledgeDateTime
                  ? formatDateDMYYYY(new Date(data?.weightOut?.acknowledgeDateTime))
                  : '-'}
              </div>
            </div>
            <div className={styles['acknowledge-container-mobile-by']}>
              <div className={styles['result-container-mobile-label']}>Acknowledge by</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightIn?.acknowledgeByName ?? '-'}</div>
              <div className={styles['result-container-mobile-item']}>{data?.weightOut?.acknowledgeByName ?? '-'}</div>
            </div>
          </div>
        </>
      )}
      {progressData && (
        <>
          <hr className={styles['progress-monitoring-line']} />
          {/* interim measurement  */}
          <div className={styles['progress-monitoring']}>
            <div className={styles['progress-monitoring-title-container']}>
              <div className={styles['progress-monitoring-title-container-title']}>Progress Monitoring</div>
              <div className={styles['progress-monitoring-title-container-subtitle']}>(Optional)</div>
              <Tooltip
                message={
                  'Progress monitoring is optional and intended solely for self-assessment. It does not affect the winning criteria.'
                }
                preference={TooltipPreference.RIGHT}
                className={styles['input-tool-tip']}
                iconName="circle-exclamation"
              />
            </div>
            {/* <div>Track your health stats and observe your progress over time!</div> */}
            <TableContainer
              enableCheckbox={false}
              dataSource={progressData ?? []}
              getColumns={progressMonitorConfig}
              pagination={true}
              rowKey={'recId'}
            />
          </div>
        </>
      )}

      {/* {isOpen && (
        <Modal
          primaryButtonLabel={''}
          headline={''}
          closeIcon={false}
          containerWidth={'800px'}
          primaryButton={
            <Button
              title={t('admin.participant.save')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                handleFileUpload();
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
            />
          }
          secondaryButton={
            <Button
              title={t('admin.participant.cancel')}
              type={ButtonTypes.BUTTON}
              onClick={handleCloseModal}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.OUTLINE}
              data-testid="test-cancel-button-popup-delete-modal"
            />
          }
        >
          <div className={styles['modal-upload']}>
            {carouselType === 'before' && (
              <div className={styles['before-container']}>
                <div className={styles['title']}>Before</div>
                <div className={styles['upload-container']}>
                  <div className={styles['image-container']}>
                    {images.before_front.url ? ( 
                    <div className={styles['image-wrapper']} style={{ position: 'relative' }}>
                      <img
                        src={images.before_front.url ? images.before_front.url : PhotoUnavailable}
                        alt="Before Front View"
                        className={styles['uploaded-image']}
                      />
                      <div className={styles['buttons-container']}>
                          <button
                            className={styles['change-photo']}
                            onClick={() => document.getElementById('before_front')?.click()}
                          >
                            <img src={ChangeButton} alt="bg" />
                            <input
                              type="file"
                              id="before_front"
                              accept="image/*"
                              onChange={e => handleFile(e, 'before_front', true)}
                              style={{ display: 'none' }}
                            />
                          </button>
                          <button
                            className={styles['remove-photo']}
                            onClick={() => handleRemoveImage('before', 'front')}
                          >
                            <img src={RemoveButton} alt="bg" />
                          </button>
                        </div>
                    </div>
                    ) : (
                      <ImageEditor onFileUpload={e => handleFileImage(e, 'front', true)} accept="image/*" />
                    )} 
                    <div className={styles['label']}>Front View</div>
                  </div>
                  <div className={styles['image-container']}>
                     {images.before_side.url ? ( 
                    <div className={styles['image-wrapper']} style={{ position: 'relative' }}>
                      <img
                        src={images.before_side.url ? images.before_side.url : PhotoUnavailable}
                        alt="Before Side View"
                        className={styles['uploaded-image']}
                      />
                      <div className={styles['buttons-container']}>
                          <button
                            className={styles['change-photo']}
                            onClick={() => document.getElementById('before_side')?.click()}
                          >
                            <img src={ChangeButton} alt="bg" />
                            <input
                              type="file"
                              id="before_side"
                              accept="image/*"
                              onChange={e => handleFile(e, 'before_side', true)}
                              style={{ display: 'none' }}
                            />
                          </button>
                          <button
                            className={styles['remove-photo']}
                            onClick={() => handleRemoveImage('before', 'side')}
                          >
                            <img src={RemoveButton} alt="bg" />
                          </button>
                        </div> 
                    </div>
                    ) : (
                      <ImageEditor onFileUpload={e => handleFileImage(e, 'side', true)} accept="image/*" />
                     )}
                    <div className={styles['label']}>Side View</div>
                  </div>
                </div>
              </div>
            )}
            {carouselType === 'after' && (
              <div className={styles['before-container']}>
                <div className={styles['title']}>After</div>
                <div className={styles['upload-container']}>
                  <div className={styles['image-container']}>
                     {images.after_front.url ? ( 
                    <div className={styles['image-wrapper']} style={{ position: 'relative' }}>
                      <img
                        src={images.after_front.url ? images.after_front.url : PhotoUnavailable}
                        alt="After Front View"
                        className={styles['uploaded-image']}
                      />
                      <div className={styles['buttons-container']}>
                          <button
                            className={styles['change-photo']}
                            onClick={() => document.getElementById('after_front')?.click()}
                          >
                            <img src={ChangeButton} alt="bg" />
                            <input
                              type="file"
                              id="after_front"
                              accept="image/*"
                              onChange={e => handleFile(e, 'after_front', false)}
                              style={{ display: 'none' }}
                            />
                          </button>
                          <button
                            className={styles['remove-photo']}
                            onClick={() => handleRemoveImage('after', 'front')}
                          >
                            <img src={RemoveButton} alt="bg" />
                          </button>
                        </div>
                    </div>
                    ) : (
                      <ImageEditor onFileUpload={e => handleFileImage(e, 'front', false)} accept="image/*" />
                    )} 
                    <div className={styles['label']}>Front View</div>
                  </div>
                  <div className={styles['image-container']}>
                    {images.after_side.url ? (
                    <div className={styles['image-wrapper']} style={{ position: 'relative' }}>
                      <img
                        src={images.after_side.url ? images.after_side.url : PhotoUnavailable}
                        alt="After Side View"
                        className={styles['uploaded-image']}
                      />
                      <div className={styles['buttons-container']}>
                          <button
                            className={styles['change-photo']}
                            onClick={() => document.getElementById('after_side')?.click()}
                          >
                            <img src={ChangeButton} alt="bg" />
                            <input
                              type="file"
                              id="after_side"
                              accept="image/*"
                              onChange={e => handleFile(e, 'after_side', false)}
                              style={{ display: 'none' }}
                            />
                          </button>
                          <button className={styles['remove-photo']} onClick={() => handleRemoveImage('after', 'side')}>
                            <img src={RemoveButton} alt="bg" />
                          </button>
                        </div>
                    </div>
                    ) : (
                      <ImageEditor onFileUpload={e => handleFileImage(e, 'side', false)} accept="image/*" />
                    )}
                    <div className={styles['label']}>Side View</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}  */}
    </Card>
  );

  //#endregion

  //#region Reward
  const rewardDetail = (
    <Card
      title={t('Reward(s)')}
      headerStyle={isDesktopView ? HeaderStyle.HEADER_5 : HeaderStyle.HEADER_6}
      containerHeight="100%"
    >
      <div className={styles['rewards']}>
        {/* <div className={styles['rewards-campaign']}>{data?.campaign.campaignName}</div> */}
        {activityNames.length > 0 ? (
          activityNames.map((activityName, idx) => (
            <>
              <div className={styles['rewards-event']}>
                {/* {isDesktopView && (
                  <div className={styles['rewards-event-icon']}>
                    <span>Event</span>
                    <p>{idx + 1}</p>
                  </div>
                )} */}
                <div className={styles['rewards-event-title']}>{activityName}</div>
              </div>
              <div className={styles['rewards-items']}>
                {data?.rewards
                  .filter(r => r.rewardStatus !== 'REMOVED')
                  .map(reward => (
                    <div className={styles['rewards-items-container']}>
                      <div className={styles['rewards-items-name']}>{reward.rewardName}</div>
                      <div className={styles['rewards-items-entitle']}>
                        <Tag
                          theme={reward?.redeemDate ? Theme.GRAY : Theme.SUCCESS}
                          style={TagStyle.OUTLINE}
                          text={
                            reward?.redeemDate
                              ? `REDEEMED (${formatDateDMYYYY(new Date(reward?.redeemDate))})`
                              : 'ACTIVE'
                          }
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </>
          ))
        ) : (
          <OperationCenterErrorCard errorType={ErrorType.NO_RECORD} className={styles['rewards-no-record']} />
        )}
      </div>
    </Card>
  );
  //#endregion

  //#region Participant Progress
  const participantProgress = (
    <Card
      title={t('Individual Progress')}
      headerStyle={isDesktopView ? HeaderStyle.HEADER_5 : HeaderStyle.HEADER_6}
      containerHeight="100%"
    >
      <div className={styles['progress']}>
        <div className={styles['team-details-container']}>
          <div className={styles['team-details-title-container']}>
            <div className={styles['team-details-coach']}>
              Campaign :<div className={styles['team-details-date-range']}>{data?.campaign.campaignName}</div>
              {data?.status && (
                <Tag
                  text={data?.status ?? ''}
                  theme={data?.status === 'ACTIVE' ? Theme.SUCCESS : Theme.PURPLE}
                  style={TagStyle.OUTLINE}
                />
              )}
            </div>
            {isDesktopView && (
              <div className={styles['team-details-coach']}>
                Coach :{' '}
                {data?.coachID && data?.coachName ? (
                  <div className={styles['team-details-date-range']}>{`${data?.coachID} - ${data?.coachName}`}</div>
                ) : (
                  '-'
                )}
              </div>
            )}
          </div>

          <div className={styles['team-details-title-container']}>
            <div className={styles['team-details-coach']}>
              Team Name :<div className={styles['team-details-date-range']}>{data?.team.teamName}</div>
            </div>
            <div className={styles['team-details-coach']}>
              <div className={styles['team-details-date-range']}>{`${
                data?.team.teamStartDate ? formatDateDMYYYY(new Date(data?.team.teamStartDate)) : 'N/A'
              } - ${data?.team.teamEndDate ? formatDateDMYYYY(new Date(data?.team.teamEndDate)) : 'N/A'}`}</div>
            </div>
          </div>

          <div>
            <div className={styles['team-details-progress-card']}>
              {data && (
                <DetailCardProgress
                  {...data}
                  showFiveProgress={false}
                  isCoachEnrollment={props.role !== 'PARTICIPANT' && data.subscribe.length === 0}
                  purchase={data?.purchase || [{ orderName: '', orderNumber: '', orderStatus: 0 }]}
                  subscribe={data?.subscribe || [{ orderNumber: '', orderStatus: 0 }]}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
  //#endregion

  return (
    <div className={styles['team-profile']}>
      <div className={styles['team-profile-header']}></div>
      <div className={styles['team-profile-top']}>
        <div>{userDetails}</div>
        {activityNames?.length > 0 && <div>{rewardDetail}</div>}
        <div>{participantProgress}</div>
      </div>
      <div className={styles['team-profile-bottom']}>{measurementDetail}</div>
      {confirmationPrompt}
      {uploadImageModal}
    </div>
  );
};
